import { EPhaseNames } from "../../shared/enums/phases.enums";
import { ContactsLabel, TimingLabel } from "../../shared/enums/labels.enums";

// TBD: Use string templates/interpolation to replace the instances of "Projected End Date"/etc in the strings with the label constants?
// It would prevent confusion in the future if the labels change by not referring to non-existent fields, but it could break grammar.

export const getBadgeTooltipMessage = (label: string): string => {
  let message;

  switch (label) {
    case "PENDING":
      message = `There is a Consumers Energy or Customer task that is not complete and may affect the ${TimingLabel.PROJECTED_END_DATE}`;
      break;
    case "ON TIME":
      message = `Currently package is on time to meet the ${TimingLabel.PROJECTED_END_DATE}`;
      break;

    // istanbul ignore next
    default:
      message = "";
      break;
  }

  return message;
};

export const PhaseNameMessageMap: Record<EPhaseNames, string> = {
  [EPhaseNames.INITIAL]:
    "Customer initiates a request for service. Consumers Energy will collect some initial information to begin project with notification.",
  [EPhaseNames.SCOPING]:
    "Customer provides project details (sketches, load requirements etc.) Design work cannot begin until completed.",
  [EPhaseNames.DESIGN]:
    "Consumers Energy will develop a solution for project/package and finalize designs. During this phase a site visit may be required.",
  [EPhaseNames.PREREQUISITES]:
    "Customer provides any remaining paperwork, including permits, inspections, staking of the site, and payments (if necessary).",
  [EPhaseNames.SCHEDULING]:
    "Site should be maintained in a ready state. Consumers Energy may come out to do a site check.",
  [EPhaseNames.CONSTRUCTION]:
    "Customer can expect a call the Friday before the work is to begin the following week. Customer must ensure that Consumers Energy has access to site and pathway is clear.",
  // @todo: need to determine what to show for this, if it is present
  [EPhaseNames.POSTING]: "",
  [EPhaseNames.COMPLETED]: "",
  [EPhaseNames.CANCELLED]: "",
};

export const TimingMessageMap: Record<TimingLabel, string> = {
  [TimingLabel.PROJECTED_END_DATE]: "The date the package will be completed.",
  [TimingLabel.EARLIEST_START_DATE]:
    "Earliest date for construction to begin. Work has been released to crew(s) and they are preparing schedules to begin.",
  [TimingLabel.REQUESTED_BY_DATE]:
    "The customer requested date to be completed. This date could vary depending on your individual project requirements.",
  [TimingLabel.ESTIMATED_SITE_READY_DATE]:
    "The projected date the customer will have the site ready for Consumers Energy.",
  [TimingLabel.AHEAD_OF_SCHEDULE]: `Business days ahead of or behind the ${TimingLabel.PROJECTED_END_DATE}.`,
  [TimingLabel.BEHIND_SCHEDULE]: `Business days ahead of or behind the ${TimingLabel.PROJECTED_END_DATE}.`,
  [TimingLabel.NEXT_SCHEDULED_CONTACT]:
    "Number of days until next Consumers Energy contact with customer.",
  [TimingLabel.MAIN_CONTACT]:
    "Is the customer name on file with Consumers Energy.",
  [TimingLabel.SCHEDULED_END_DATE]:
    "Anticipated date for completion of this construction package. Entire Project may require multiple crews/visits.",
};

export const ContactsMessageMap: Record<ContactsLabel, string> = {
  [ContactsLabel.COORDINATOR]:
    "Is the current Consumers Energy point of contact assigned to your project.",
  [ContactsLabel.MAIN_CONTACT]:
    "Is the customer name on file with Consumers Energy.",
};
